import React from "react";

import { CheckIcon } from "@/Components/Icons/CheckIcon";

/**
 * Renders a candidate type filter component.
 *
 * @param {object} active - The active candidate type value
 * @param {function} handleClick - The click event handler function
 * @return {JSX.Element} The rendered candidate type filter component
 */
const CandidateTypeFilter = ({ active, handleClick }) => {
  const data = [
    {
      name: "Not Register",
      value: "not_registered",
    },
    {
      name: "Not compliant",
      value: "not_compliant",
    },
    {
      name: "Fully compliant",
      value: "fully_compliant",
    },
  ];

  const handleItemClick = (value) => {
    handleClick(
      active.includes(value)
        ? active.filter((item) => item !== value)
        : [...active, value],
    );
  };

  return (
    <div className="CandidateTypeFilter_Wrapper">
      <div className="grid gap-3">
        <label className="label text-black" htmlFor="candidateType">
          Candidate Type
        </label>
        <div className="flex gap-4">
          {data.map((item, index) => {
            return (
              <div
                key={index}
                className={`ease flex cursor-pointer items-center gap-2 rounded-lg px-4 py-2 transition-all duration-300 ${
                  active.includes(item.value)
                    ? "bg-primary text-white"
                    : "bg-grey text-txtColor hover:bg-lightblue"
                }`}
                onClick={() => {
                  handleItemClick(item.value);
                }}
              >
                <span
                  className={`block overflow-hidden !text-white transition-all duration-300 ${active.includes(item.value) ? "w-[14px]" : "w-0"}`}
                >
                  <CheckIcon />
                </span>
                <span className="text-[14px]" htmlFor="candidateType">
                  {item.name}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CandidateTypeFilter;
